/** Tipos de apoio do editor visual de condição (só UI; o contrato é o de `core/condicao`). */
import {
  CondicaoAtomica,
  Condicao,
  Operador,
  TipoCampoCondicao,
} from '../../../../core/condicao/tipos'

export type OpcaoReferencia = {
  codigo: string
  descricao: string
}

/** Campo do formulário como o editor o enxerga na lista de referências. */
export type CampoReferenciavel = {
  /** Vazio quando o campo ainda não tem código: aparece desabilitado na lista. */
  codigo: string
  rotulo: string
  tipo: TipoCampoCondicao
  multiplo: boolean
  opcoes: OpcaoReferencia[]
}

/** Linha em edição: `ref` pode estar vazia enquanto o usuário não escolhe. */
export type LinhaEmEdicao = CondicaoAtomica

export const LINHA_NOVA: LinhaEmEdicao = { fonte: 'campo', ref: '', op: '=' }

export const ehLinha = (no: Condicao): no is LinhaEmEdicao =>
  !Array.isArray((no as { todos?: unknown }).todos) &&
  !Array.isArray((no as { algum?: unknown }).algum)

/** Categoria de valor que o editor deve oferecer para o operador escolhido. */
export type FormatoValor = 'nenhum' | 'intervalo' | 'lista' | 'escalar'

export const formatoDoOperador = (op: Operador): FormatoValor => {
  if (op === 'existe' || op === 'nao_existe') return 'nenhum'
  if (op === 'entre') return 'intervalo'
  if (op === 'em') return 'lista'
  return 'escalar'
}
